import { motion } from "framer-motion";
import type { Task } from "../../types";
import { SingleTaskCard } from "./TaskRevealCard";
import { cardContentVariants, detailReveal } from "./motion";

export function TaskResult({
  balanceAfter,
  isLaunching,
  onLaunch,
  onReject,
  task,
  canLaunch,
}: {
  balanceAfter?: number | null;
  isLaunching: boolean;
  onLaunch: () => void;
  onReject: () => void;
  task: Task;
  canLaunch: boolean;
}) {
  return (
    <motion.div className="task-reveal-layout" variants={cardContentVariants}>
      <SingleTaskCard task={task} />

      <motion.div className="task-reveal-details" variants={detailReveal}>
        <div className="task-reveal-actions">
          <div
            className="not-for-me"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <button
              className="btn btn-outline"
              onClick={onReject}
              type="button"
              style={{ height: 40 }}
            >
              Not for me
            </button>
            <div
              className="tag task-reveal-card__reward-label"
              style={{
                whiteSpace: "pre-wrap",
                // width: 170,
                textAlign: "center",
                margin: "auto",
              }}
            >
              Don't worry, this task will be available next time too!
            </div>
          </div>
          <button
            className="btn btn-accent"
            disabled={isLaunching || !canLaunch}
            onClick={onLaunch}
            type="button"
            style={{ height: 40 }}
          >
            {isLaunching ? "Starting..." : "Let's go!"}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
